import axios from "@/plugins/Axios";

const model = "categories";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

function find(id) {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

function create(category) {
  return axios.post(`${process.env.VUE_APP_API_URL}/${model}`, category);
}

function update(id, category) {
  return axios.put(`${process.env.VUE_APP_API_URL}/${model}/${id}`, category);
}

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { all, find, create, update, remove };
